module.exports = __webpack_public_path__ + "img/ill_approval_default.a7a18f8a.svg";